import Navbar from "../../component/Navbar";
import Footer from "../../component/Footer";
import { Link } from "react-router-dom";

const Audio4 = () => {
  return (
    <div>
      <Navbar />
        <div className="text-black ml-20 mt-5">
          <Link to="/mainaudiopage">
            <button className="flex gap-1 px-4 py-2 rounded-xl w-fit"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="w-4 h-6">
            <path strokeLinecap="round" strokeLinejoin="round" d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18" />
            </svg>
              Back
            </button>
          </Link>
        </div>
          <h1 className="text-[#314C1C] text-3xl text-center font-bold pt-5 ">
          PROBLEM SOLVING TO HEALING
          </h1>
        <div className="lg:items-center justify-center mx-20 my-5 px-10 py-7 bg-[#DCAE96] mb-10 ">
            <div className="w-full md:grid md:justify-center md:items-center md:place-content-center">     
              <Link to=""
              >
                <div>
                <img
                  src="https://res.cloudinary.com/dzqx4v0al/image/upload/v1702597171/medium-shot-woman-sitting-chair_uwd30f.jpg"
                  alt="audio-img"
                  className="w-full md:w-[400px] md:h-[250px] rounded-md text-center object-cover"
                />
                <audio controls src="https://res.cloudinary.com/djltdw88d/video/upload/v1701287327/audio1-4%20audios/eeoaxholqw30djdc0kna.mp3" className="w-full md:w-[400px]">
              </audio>
                </div>
              </Link>
              
              <div className="flex flex-col lg:flex-row lg:gap-16 gap-4 px-4 py-5 justify-center">
                <Link
                  to="https://res.cloudinary.com/djltdw88d/video/upload/v1701287327/audio1-4%20audios/eeoaxholqw30djdc0kna.mp3">
                  <button
                    className="flex justify-center items-center text-[whitesmoke] font-medium bg-[#314C1C] p-3 rounded-md border-none">
                    DOWNLOAD
                  </button>
                </Link>
              </div>
            </div>
        
          <section className="md:mt-5 content-center justify-center items-center place-content-center px-5">
            <div className="content-center justify-center items-center place-content-center">
              <p className="text-[#314C1C] text-md text-justify text-[20px]">
              Problem solving is often driven by a desire to find solutions and
              overcome obstacles. It requires analytical thinking,
              resourcefulness, and determination. While this approach is
              essential for navigating the complexities of life, it sometimes
              focuses solely on external fixes, neglecting the internal
              landscapes where healing truly takes root. As we embrace healing,
              we cultivate resilience, deepen our capacity for empathy, and open
              ourselves to a richer, more authentic existence.
              </p>
            </div>
          </section>
        </div>

      <Footer />
    </div>
  );
};

export default Audio4;
